export const MAIN_CONTENT_WIDTH = 1100;
export const INSET_CONTAINER_WIDTH = 820;
export const TRIANGLE_HEIGHT = '5rem';
export const CALCULATED_MIN_HEIGHT = `calc(100vh - calc(${TRIANGLE_HEIGHT} * 1.6))`;
